import {Component, OnInit} from '@angular/core';
import {AbstractProfileValidator} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/base/abstract-profile-validator";
import {FormBuilder} from "@angular/forms";
import {EventProfileType} from "@biletix/core/common/enums/event-profile-type.enum";

@Component({
    standalone: false,
    selector: 'btx-vodafone-profile-validator',
    templateUrl: './vodafone-profile-validator.component.html',
    styleUrls: ['./vodafone-profile-validator.component.scss']
})
export class VodafoneProfileValidatorComponent extends AbstractProfileValidator implements OnInit {

    isDiscountApplied: boolean = false;

    constructor(fb: FormBuilder) {
        super(fb);
    }

    ngOnInit(): void {
        this.initializeValidationFormGroup(this.validationFieldConfigs);
    }


    public validatorClasses() {
        return {
            'vodafone-red': this.profile.profileType == EventProfileType.VODAFONERED,
            'vodafone-free-zone': this.profile.profileType == EventProfileType.VODAFONEFREEZONE,
            'vodafone-default': this.profile.profileType == EventProfileType.VODAFONE,
        }
    }


    onValidateProfile() {
        if (this.validationFormGroup.invalid) {
            this.validationFormGroup.markAllAsTouched();
            return;
        }

        const validationFields: any[] = this.validationFormGroup.value;

        this.isDiscountApplied=!this.isDiscountApplied;
        //TODO: validate vodafone profile
        //service call


    }

}
